/**
 * @generated SignedSource<<c4df11ceae42531b67f2cbcdc5000819>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs, Result } from "relay-runtime";
export type useTitleContentPropertiesFragment_content$data = Result<{
  readonly id: string | null;
  readonly metadata: {
    readonly frontend: {
      readonly coverPictureWidth: string | null;
    } | null;
  };
  readonly pageTitleDraft: {
    readonly nodes: ReadonlyArray<{
      readonly id: string | null;
      readonly key: string | null;
      readonly value: string | null;
      readonly version: {
        readonly number: number | null;
      } | null;
    } | null> | null;
  } | null;
  readonly pageTitlePublished: {
    readonly nodes: ReadonlyArray<{
      readonly id: string | null;
      readonly key: string | null;
      readonly value: string | null;
      readonly version: {
        readonly number: number | null;
      } | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "useTitleContentPropertiesFragment_content";
}, unknown>;
export type useTitleContentPropertiesFragment_content$key = {
  readonly " $data"?: useTitleContentPropertiesFragment_content$data;
  readonly " $fragmentSpreads": FragmentRefs<"useTitleContentPropertiesFragment_content">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = [
  {
    "concreteType": "JsonContentProperty",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      (v0/*: any*/),
      {
        "kind": "ScalarField",
        "name": "key"
      },
      {
        "kind": "ScalarField",
        "name": "value"
      },
      {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "number"
          }
        ]
      }
    ]
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "catchTo": "RESULT"
  },
  "name": "useTitleContentPropertiesFragment_content",
  "selections": [
    (v0/*: any*/),
    {
      "alias": "pageTitlePublished",
      "args": [
        {
          "kind": "Literal",
          "name": "key",
          "value": "page-title-property-published"
        }
      ],
      "concreteType": "PaginatedJsonContentPropertyList",
      "kind": "LinkedField",
      "name": "properties",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": "properties(key:\"page-title-property-published\")"
    },
    {
      "alias": "pageTitleDraft",
      "args": [
        {
          "kind": "Literal",
          "name": "key",
          "value": "page-title-property-draft"
        }
      ],
      "concreteType": "PaginatedJsonContentPropertyList",
      "kind": "LinkedField",
      "name": "properties",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": "properties(key:\"page-title-property-draft\")"
    },
    {
      "concreteType": "ContentMetadata",
      "kind": "LinkedField",
      "name": "metadata",
      "plural": false,
      "selections": [
        {
          "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
          "kind": "LinkedField",
          "name": "frontend",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "coverPictureWidth"
            }
          ]
        }
      ]
    }
  ],
  "type": "Content"
};
})();

(node as any).hash = "93a5adb1af5ee84f76aa2f7ec3792118";

export default node;
